type IconMetadata = {
  svg: string;
  viewBox: string;
};

/**
 * Store icon viewbox metadata in memory to avoid computing viewbox for an icon multiple times.
 */
class IconViewBoxCache {
  private idMap: Map<string, IconMetadata>;
  private static instance: IconViewBoxCache;

  constructor() {
    this.idMap = new Map();
  }

  add = (iconId: string, iconMetadata: IconMetadata) => {
    this.idMap.set(iconId, iconMetadata);
  };

  get = (iconId: string): IconMetadata | undefined => this.idMap.get(iconId);

  public static getInstance(): IconViewBoxCache {
    if (!IconViewBoxCache.instance) {
      IconViewBoxCache.instance = new IconViewBoxCache();
    }

    return IconViewBoxCache.instance;
  }
}

export const iconViewBoxCache = IconViewBoxCache.getInstance();
